<div class="dialog-container">
  <h1 mat-dialog-title>
    <mat-icon class="dialog-icon">social_distance</mat-icon>
    {{ data.title }}
  </h1>
  
  <div mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
    
    <mat-form-field class="usuario-select">
      <mat-label>Selecione o novo proprietário</mat-label>
      <mat-select [(ngModel)]="usuarioSelecionado" required>
        <mat-option *ngFor="let usuario of data.usuarios" [value]="usuario.idUsuario">
          {{ usuario.noNomeCompleto }} - {{ usuario.noCpfj }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-raised-button (click)="onCancelar()">
      Cancelar
    </button>
    <button mat-button mat-raised-button color="primary" 
            (click)="onConfirmar()" 
            [disabled]="!usuarioSelecionado">
      Confirmar
    </button>
  </div>
</div>
